import { createApi } from '@reduxjs/toolkit/query/react'

import { ActivitiesDone } from '~/homebase/types/Homebase.types'

import { apiPrivate } from '~/redux/utils/hom-api'
import { FunFactChestEvent } from '~/bootcamp/types/bootcamp.types'

import { ActivityCategory, GenerationMethod, ActivityMetadata } from './types'

export const activityApi = createApi({
  reducerPath: 'activityApi',
  baseQuery: apiPrivate,
  tagTypes: ['Activity'],
  endpoints: (builder) => ({
    getActivityStats: builder.query<
      { startDate: string; endDate: string },
      { correctAnswers: number; wrongAnswers: number }
    >({
      query: (params) => ({
        url: '/v1/activity/stats',
        method: 'GET',
        params,
      }),
      providesTags: ['Activity'],
    }),

    addActivityAttempt: builder.mutation<
      void,
      {
        attempts: Array<{
          correct: boolean
          activityCategory: ActivityCategory
          generationMethod: GenerationMethod
          path: string
          metadata: ActivityMetadata
          isShowGrade?: boolean
        }>
      }
    >({
      query: (body) => ({
        url: '/v1/activity',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['Activity'],
    }),

    addOtherActivityAttempt: builder.mutation<
      void,
      {
        attempts: Array<{
          status: string
          activityCategory: ActivityCategory
          generationMethod: GenerationMethod
          path: string
          variationKey: string
          metadata: ActivityMetadata
        }>
      }
    >({
      query: (body) => ({
        url: '/v1/other-activity',
        method: 'POST',
        body,
      }),
    }),

    createFunFactChestEvent: builder.mutation<void, FunFactChestEvent>({
      query: (body) => ({
        url: '/v1/activity/fun-fact-chests/events',
        method: 'POST',
        body,
      }),
      invalidatesTags: [],
    }),

    getActivitiesSinceDate: builder.query<ActivitiesDone[], { startDate: string }>({
      query: (params) => ({
        url: `/v1/my-activities`,
        method: 'GET',
        params,
      }),
    }),
    setUpdateMultChoiceTestProgress: builder.mutation<{ success: boolean }, { taskId: string }>({
      query: (data) => ({
        url: '/v1/activities/math-essentials',
        method: 'POST',
        body: data,
      }),
    }),
  }),
})

export const {
  useGetActivityStatsQuery,
  useGetActivitiesSinceDateQuery,
  useAddActivityAttemptMutation,
  useCreateFunFactChestEventMutation,
  useLazyGetActivitiesSinceDateQuery,
  useAddOtherActivityAttemptMutation,
  useSetUpdateMultChoiceTestProgressMutation,
} = activityApi
